import React, { Component } from 'react'
import CacheKeys from '../../../cache/CacheKeys'
import CacheManager from '../../../cache/CacheManager'
import RestApiUtils from '../../../apiclient/moebli/RestApiUtils'
import MonitoringPropertyListUI from './MonitoringPropertyListUI.js'

class MonitoringPropertyListSF extends Component {
  constructor(props) {
    super(props)
    this.state = {
      errorList: null,
      propertyList: null,
      updateMode: false,
      selectedProperty: null
    }
  }

  render() {
    return (
      <MonitoringPropertyListUI
        context={this.props.context}
        errorList={this.state.errorList}
        propertyList={this.state.propertyList}
        selectedProperty={this.state.selectedProperty}
        updateMode={this.state.updateMode}
        loan={this.props.loan}
        // events
        onRefreshClick={this.onRefreshClick}
        onUpdateClick={this.onUpdateClick}
        onCancelClick={this.onCancelClick}
        onUpdate={this.onUpdate}
      />
    )
  }

  componentDidMount() {
    let context = this.props.context
    this.getProperties(context)
  }

  getProperties(context) {
    let cacheManager = new CacheManager({
      resource: `/api/su/loans/${this.props.loan.loanId}/properties/monitoring`,
      cacheKey: CacheKeys.LoanProperties(this.props.loan.loanId),
      callback: this.getPropertiesCallback,
      ttlInSecs: 3600
    })
    cacheManager.getObject2(context)
  }

  getPropertiesCallback = (response) => {
    this.setState({errorList: response.errorList, propertyList : response.loanPropertyList})
  }

  onUpdateClick = (event) => {
    let propertyCode = event.currentTarget.getAttribute('data-property')
    console.log(propertyCode);
    let selectedProperty = this.state.propertyList.filter(p => p.propertyCode === propertyCode)[0]
    this.setState({updateMode: true, selectedProperty: selectedProperty})
  }

  onCancelClick = () => {
    this.setState({updateMode:false, errorList: null})
  }

  onUpdate = (selectedProperty) => {
    CacheManager.removeObject(CacheKeys.LoanProperties(this.props.loan.loanId))
    this.setState({propertyList : this.state.propertyList})
  }

  onRefreshClick = () => {
    CacheManager.removeObject(CacheKeys.LoanProperties(this.props.loan.loanId))
    this.setState(
      {
        propertyList: null,
        errorList: null,
      }, this.getProperties(this.props.context)
    )
  }
}

export default MonitoringPropertyListSF
